<!-- <button class="Show">Show</button>
<button class="Hide">Hide</button>
<button class="togglee">Show &amp; Hide</button> -->
<div id="target" class="py-3">
   <div class="container">
      <div class="row">
         <div class="col-md-4 col-sm-6 py-2 mb-4">
            <label>Status</label>
            <select class="selectpicker form-control" style="border-radius: 40px;">
               <option selected="selected">Select one</option>
               <option value="1">1</option>
               <option value="2">2</option>
               <option value="3">3</option>
           </select>
         </div>
         <div class="col-md-4 col-sm-6 py-2 mb-4">
            <label>Status</label>
            <select class="selectpicker form-control" style="border-radius: 40px;">
               <option selected="selected">Select one</option>
               <option value="1">1</option>
               <option value="2">2</option>
               <option value="3">3</option>
           </select>
         </div>
         <div class="col-md-4 col-sm-6 py-2 mb-4">
            <label>Status</label>
            <select class="selectpicker form-control" style="border-radius: 40px;">
               <option selected="selected">Select one</option>
               <option value="1">1</option>
               <option value="2">2</option>
               <option value="3">3</option>
           </select>
         </div>  
         <div class="col-md-4 col-sm-6 py-2 mb-4">
            <label>Status</label>
            <select class="selectpicker form-control" style="border-radius: 40px;">
               <option selected="selected">Select one</option>
               <option value="1">1</option>
               <option value="2">2</option>
               <option value="3">3</option>
           </select>
         </div>  
         <div class="col-md-4 col-sm-6 py-2 mb-4">
            <label>Status</label>
            <select class="selectpicker form-control" style="border-radius: 40px;">
               <option selected="selected">Select one</option>
               <option value="1">1</option>
               <option value="2">2</option>
               <option value="3">3</option>
           </select>
         </div>                           
      </div>
   </div>
</div>


<div class="title pt-3">
  <div class="container py-3">
      <div class="row">
          <div class="col">
              <ul class="list-inline">
                <li class="list-inline-item"><h6 class="Category">Booking</h6></li>
                <li class="list-inline-item"><i class="fas fa-angle-right"></i></li>
                <li class="list-inline-item"><h6 class="active-page">Calender</h6></li>
              </ul>
          </div>
          <div class="col">
            <a href="#" class="float-right" style="color:#28346F;font-weight:bold">
            <ul class="list-inline hvr-shrink">
              <li class="list-inline-item"><img class="img-fluid" src="assets/images/plus.png"></li>
              <li class="list-inline-item">Add New</li>
            </ul>
          </a>
        </div>      
      </div>
    </div>
</div>

<div class="container mb-3">
<div class="filteration">
   <div class="row">
       <div class="col-lg-3 col-md-4">
         <h5 class="pt-2 font-weight-bold">22 April 2020</h5>
       </div>
       <div class="col-lg-6 col-md-8">
          <input type="text" placeholder="Search with client nam or mobile number ..." class="mt-1 form-control">
       </div>
       <div class="col-lg-3 col-md-12">
           <button class="btn togglee"><img class="img-fluid mx-1" src="assets/images/filter.png">Filter</button>
       </div>
   </div>
</div>
</div>

<div class="container">
  <table class="table table-borderless table-responsive-lg">
      <thead>
        <tr class="bg-none">
          <th scope="col"></th>
          <th scope="col">Date</th>
          <th scope="col">Client</th>
          <th scope="col">Mobile</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr> 
          <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
          <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
             <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
             <li class="list-inline-items mx-1">Edit</li>
          </ul></td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>   
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>   
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Confirmed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>   
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>
        <tr>
         <th class="bg-white" scope="row"><img src="assets/images/arrow.png"></th>
         <td>28 / 0 / 2020</td>
          <td>Waleed Gamal</td>
          <td>0123456789</td>
          <td>Closed</td>
          <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/pencil.png"></li>
              <li class="list-inline-items mx-1">Edit</li>
           </ul></td>            
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/credit-card.png"></li>
              <li class="list-inline-items mx-1">Payment</li>
           </ul></td>              
           <td><ul class="list-inline d-flex">
              <li class="list-inline-items"><img class="img-fluid" src="assets/images/refund.png"></li>
              <li class="list-inline-items mx-1">Refund</li>
           </ul></td>  
        </tr>                                                  
      </tbody>
    </table>
</div>

